import { Space, Typography } from 'antd';
import { BORROWING_STATUS_LABELS } from '@liyu/shared-types';
import { ErrorAlert } from '../../components/ErrorAlert';
import { useCanManageLibrary } from '../../auth/usePermissions';
import { useLibraryTodoCounts } from '../../hooks/useMenuBadges';
import { TodoStatCard } from '../dashboard/TodoStatCard';

/**
 * 概览页「图书借阅」待办块（33 号 §7.2 书房总览/待处理 + 概览页改造）：
 *
 * 只展示需要运营动手的 4 项（待审核/待领取/待归还确认/已逾期）；
 * 「借阅中」「排队预约」属于存量状态，降级为底部一行小字，不占待办位。
 *
 * 计数走 useLibraryTodoCounts（queryKey 与侧边栏角标共享，A-21 聚合端点
 * 上线后可一处替换为 /admin/dashboard/summary）。
 */
export function LibraryPendingCard(): React.ReactElement | null {
  const canManage = useCanManageLibrary();
  const query = useLibraryTodoCounts(canManage);

  if (!canManage) {
    return null;
  }

  const todos: Array<{ title: string; value: number; to: string; danger?: boolean }> = [
    {
      title: '借阅申请待审核',
      value: query.data?.requested ?? 0,
      to: '/library/borrowings?status=REQUESTED',
    },
    {
      title: BORROWING_STATUS_LABELS.APPROVED,
      value: query.data?.approved ?? 0,
      to: '/library/borrowings?status=APPROVED',
    },
    {
      title: BORROWING_STATUS_LABELS.RETURN_REQUESTED,
      value: query.data?.returnRequested ?? 0,
      to: '/library/borrowings?status=RETURN_REQUESTED',
    },
    {
      title: BORROWING_STATUS_LABELS.OVERDUE,
      value: query.data?.overdue ?? 0,
      to: '/library/overdue',
      danger: true,
    },
  ];

  return (
    <Space orientation="vertical" size={12} style={{ width: '100%' }}>
      {query.isError ? (
        <ErrorAlert error={query.error} onRetry={() => void query.refetch()} />
      ) : (
        <Space size={12} wrap>
          {todos.map((item) => (
            <TodoStatCard key={item.title} {...item} />
          ))}
        </Space>
      )}
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        存量：借阅中 {query.data?.borrowed ?? 0} 条 · 排队预约 {query.data?.reservations ?? 0} 条
        （详见「图书借阅」菜单）
      </Typography.Text>
    </Space>
  );
}
